import './revenueStats.css'

import classNames from 'classnames'
import { InfoElement } from 'components'
import { moment } from 'locale'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { formatNumber, formatValidNumber, getAmountLabelForNumber } from 'utils'

const getDate = date => (typeof date === 'string' ? date : moment(date).format('L'))

function RevenueStats({
  avgDifference,
  avgValue,
  currency,
  date,
  hideAvg,
  hideTraffic,
  marginValueCurrent,
  marginVisibility,
  showDate,
  totalDifference,
  totalValue,
  traffic,
  trafficDifference,
}) {
  const { t: translate } = useTranslation()

  return (
    <div className="revenue-stats">
      {showDate && (
        <>
          <p className="revenue-stats_date label">{translate('date.comparisonDate')}:</p>
          <p className="revenue-stats_date">{getDate(date)}</p>
        </>
      )}
      <div className="revenue-stats_general">
        <span className={classNames('revenue-stats_value', { 'is-empty': !totalValue })}>
          {formatNumber(totalValue, translate, totalValue < 0 ? 0 : 2)}
        </span>
        <span className="revenue-stats_currency"> {getAmountLabelForNumber(totalValue, translate, currency)}</span>

        {marginVisibility && (
          <div className="general-revenue_main-margin-value">
            <i className="fm fm-margin" />
            {formatNumber(marginValueCurrent, translate, marginValueCurrent < 0 ? 0 : 2)}{' '}
            {getAmountLabelForNumber(marginValueCurrent, translate, currency)}
          </div>
        )}
      </div>
      <InfoElement percentDifference={totalDifference} />
      {!hideAvg && (
        <InfoElement
          hidePercent={!avgValue}
          label={translate('revenue.stats.average')}
          percentDifference={avgDifference}
          value={`${formatNumber(avgValue, translate)} ${getAmountLabelForNumber(avgValue, translate, currency)}`}
        />
      )}
      {!hideTraffic && (
        <InfoElement
          hidePercent={!traffic}
          label={translate('revenue.stats.traffic')}
          percentDifference={trafficDifference}
          value={formatValidNumber(traffic)}
        />
      )}
    </div>
  )
}

RevenueStats.propTypes = {
  avgDifference: PropTypes.object,
  avgValue: PropTypes.number,
  currency: PropTypes.string,
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  hideAvg: PropTypes.bool,
  hideTraffic: PropTypes.bool,
  marginValueCurrent: PropTypes.number,
  marginVisibility: PropTypes.bool,
  showDate: PropTypes.bool,
  totalDifference: PropTypes.object,
  totalValue: PropTypes.number,
  traffic: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  trafficDifference: PropTypes.object,
}

export default RevenueStats
